// export const server = 'http://127.0.0.1:8000';


export const server = 'https://react.brandmarkt.ch/laravel-backend';